<div class="tw-flex tw-flex-row tw-justify-between tw-gap-2">
  <div class="tw-flex tw-gap-2 tw-w-full">
    <ng-content select="[slot=start]"></ng-content>
    <ng-content></ng-content>
  </div>
  <ng-content select="[slot=end]"></ng-content>
</div>
